module.exports = __webpack_public_path__ + "static/media/temp_chart2.bb4b68c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/colonyGame/temp_chart2.png
// module id = 2280
// module chunks = 0